export default __webpack_public_path__ + "static/media/logo_TechMarket.4ca51fe7.gif";